export const breakpoints = {
  desktop: 1440,
  smallDesktop: 1152, // Design team did not define a final value yet.
  tablet: 862, // Did not define a final value yet. (For now it's not being used, it will be important when we start improving the responsive design.)
  mobile: 480,
};
